export default __webpack_public_path__ + "static/media/safezoneOn.4459e6fa.svg";